import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DataService } from '../../../../Autofacets-Core/src/app/services/data.service';
import { AppointmentRequestModel } from '../business-entities/appointmentList-model';
import { GenericResponse } from '../business-entities/generic-response';
import { AppointmentJobPackageModel, WorkOrderDetailsViewModel, WorkOrderHistoryViewModel } from '../business-entities/work-order-details-view-model';
import { Urls } from './../../../../Autofacets-Core/src/app/utils/urls';
import { DealerServiceFilterModel } from '../../../../Widget/src/app/business-entities/dealer-service-filter-model';
import { UploadDocumentRequestModel } from 'projects/Autofacets-Core/src/app/business-entities/upload-document-request-model';
import { FileUploadModel } from 'projects/Autofacets-Core/src/app/business-entities/document-model';
@Injectable({
  providedIn: 'root'
})

export class AppointmentDataService {
  constructor(private dataProvider: DataService,
    private http: HttpClient) {
  }

  GetDealerRentalCars(dealerId: any): Promise<GenericResponse<any>> {
    return this.dataProvider.Get<GenericResponse<any>>(Urls.GetDealerRentalCars, dealerId).toPromise();
  }
  GetGenericRentalCars(languageId: string): Promise<GenericResponse<any>> {
    return this.dataProvider.Get<GenericResponse<any>>(Urls.GetGenericRentalCars, languageId).toPromise();
  }
  GetAppointmentList(appointmentRequestModel: AppointmentRequestModel): Promise<GenericResponse<any>> {
    return this.dataProvider.Post<GenericResponse<any>>(Urls.GetAppointmentList, appointmentRequestModel).toPromise();
  }
  GetAdditionalWorkDetails(id: number): Promise<any> {
    return this.dataProvider.Get<GenericResponse<any>>(Urls.GetAdditionalWorkDetails, id).toPromise();
  }
  UpdateAppointmentStatus(model: any): Promise<GenericResponse<any>> {
    return this.dataProvider.Post<GenericResponse<any>>(Urls.UpdateAppointmentStatus, model).toPromise();
  }

  UpdateOnHoldStatus(model: any): Promise<GenericResponse<any>> {
    return this.dataProvider.Post<GenericResponse<any>>(Urls.UpdateOnHoldStatus, model).toPromise();
  }

  UpdateAppointmentStatusList(model: any): Promise<GenericResponse<any>> {
    return this.dataProvider.Post<GenericResponse<any>>(Urls.UpdateAppointmentStatusList, model).toPromise();
  }
  async GetAppointmentStatusList(languageCode: string): Promise<GenericResponse<any>> {
    return this.dataProvider.Get<GenericResponse<any>>(Urls.GetAppointmentStatusList, languageCode).toPromise();
  }
  GetNextAvailableStatus(statusId: number, language: string,appointmentId:number): Promise<any> {
    return this.dataProvider.Get<GenericResponse<any>>(Urls.GetNextAvailbleStatus, statusId, language,appointmentId).toPromise();
  }
  GetAllDealerDetails(model: any): Promise<GenericResponse<any>> {
    return this.dataProvider.Post<GenericResponse<any>>(Urls.GetAllDealerDetails, model).toPromise();
  }
  GetCustomerWaitingLimit(model: any): Promise<GenericResponse<any>> {
    return this.dataProvider.Post<GenericResponse<any>>(Urls.GetCustomerWaitingTime, model).toPromise();
  }
  GetAdditionalServices(dealerId: string): Promise<GenericResponse<any>> {
    return this.dataProvider.Get<GenericResponse<any>>(Urls.GetAdditionalServices, dealerId).toPromise();
  }
  GetSelectServiceSectionDetails(LanguageCode: string): Promise<GenericResponse<any>> {
    return this.dataProvider.Get<GenericResponse<any>>(Urls.GetSelectServiceSectionDetails, LanguageCode).toPromise();
  }
  GetAppointmentService(Id: number): Promise<any> {
    return this.dataProvider.Get<GenericResponse<any>>(Urls.GetAppointmentService, Id).toPromise();
  }
 
  GetServicesByDealerId(dealerServiceFilterModel:DealerServiceFilterModel): Promise<any> {
    return this.dataProvider.Post<GenericResponse<any>>(Urls.GetServicesByDealerId,dealerServiceFilterModel).toPromise();
  }

  GetServiceDetail(Id: number, AppointmentGuid: any, languageCode: any = ""): Promise<any> {
    return this.dataProvider.Get<GenericResponse<any>>(Urls.GetServiceDetails, Id, AppointmentGuid, languageCode).toPromise();
  }

  GetServicDetailForInvoice(appointmentGUID: string, pdfType: number): Promise<any> {
    return this.dataProvider.Get<GenericResponse<any>>(Urls.GetInvoiceDetails, appointmentGUID, pdfType).toPromise();
  }

  GetAdditionalServiceDetail(Id: number): Promise<any> {
    return this.dataProvider.Get<GenericResponse<any>>(Urls.GetAdditionalServiceDetails, Id).toPromise();
  }

  async SearchLicensePLate(LicensePLate: string,VINNo:string,EngineNo:string): Promise<any> {
    return this.dataProvider.Get<GenericResponse<any>>(Urls.SearchLicensePLate, LicensePLate,VINNo,EngineNo).toPromise();
  }

  GetAllStatus(model: any): Promise<any> {
    return this.dataProvider.Post<GenericResponse<any>>(Urls.GetAllStatus, model).toPromise();
  }

  GetOnHoldStatusReasonList(language: string,reasonTypeId:number): Promise<any> {
    return this.dataProvider.Get<GenericResponse<any>>(Urls.GetOnHoldStatusReasonList, language,reasonTypeId).toPromise();
  }

  GetPdfType(): Promise<any> {
    return this.dataProvider.Get<GenericResponse<any>>(Urls.GetPdfType).toPromise();
  }

  GetAllWorkOrderStatus(model: any): Promise<any> {
    return this.dataProvider.Post<GenericResponse<any>>(Urls.GetAllWorkOrderStatus, model).toPromise();
  }

  GetAppointmentDetail(Id: number, languageCode: string): Promise<any> {
    return this.dataProvider.Get<GenericResponse<any>>(Urls.GetAppointmentDetail, Id, languageCode).toPromise();
  }

  AddAppointment(viewmodel: any): Promise<any> {
    return this.dataProvider.Post<GenericResponse<any>>(Urls.AddAppointment, viewmodel).toPromise();
  }

  AddCrmAppointment(viewmodel: any): Promise<any> {
    return this.dataProvider.Post<GenericResponse<any>>(Urls.AddCrmAppointment, viewmodel).toPromise();
  }

  UpdateAppointment(viewmodel: any): Promise<any> {
    return this.dataProvider.Put<GenericResponse<any>>(Urls.UpdateAppointment, viewmodel).toPromise();
  }
  
  GetClockinDemandDetails(viewmodel:any):Promise<any>{
    return this.dataProvider.Post<GenericResponse<any>>(Urls.GetClockinDemandDetails, viewmodel).toPromise();
  }

  UpdateAdditionalAppointment(viewmodel: any): Promise<any> {
    return this.dataProvider.Put<GenericResponse<any>>(Urls.UpdateAdditionalWork, viewmodel).toPromise();
  }

  DeleteAppointment(deleteModel: any): Promise<any> {
    return this.dataProvider.Post<GenericResponse<any>>(Urls.DeleteAppointment, deleteModel).toPromise();
  }
  UpdateNeedAttention(viewModel: any): Promise<any> {
    return this.dataProvider.Post<GenericResponse<any>>(Urls.UpdateNeedAttention, viewModel).toPromise();
  }

  getDemandDescription(appointmentId: any, isWARAppointment:boolean): Promise<any>{
    return this.dataProvider.Get<GenericResponse<any>>(Urls.GetDemandDescription,appointmentId,isWARAppointment).toPromise();
  }

  SearchDealerParts(dealerId: string, partSearchText: string, languageCode: string): Promise<any> {
    return this.dataProvider.Get<GenericResponse<any>>(Urls.SearchDealerParts, dealerId, partSearchText, languageCode).toPromise();
  }

  getStatusBrand(dealerId: string, appointmentId: number, languageCode: string): Promise<any> {
    return this.dataProvider.Get<GenericResponse<any>>(Urls.GetStatusBrand, dealerId, appointmentId, languageCode).toPromise();
  }

  getActiveAppointment(vehicleId: number, customerId: number, languageCode: string): Promise<any> {
    return this.dataProvider.Get<GenericResponse<any>>(Urls.GetActiveAppointmentForVehicle, vehicleId, customerId, languageCode).toPromise();
  }
  UpdateAdditionalWorkDetails(model: any): Promise<any> {
    return this.dataProvider.Post<any>(Urls.UpdateWorkOrderDetails, model).toPromise();
  }

  GetActiveWorkOrder(model: any): Promise<GenericResponse<Array<WorkOrderDetailsViewModel>>> {
    return this.dataProvider.Post<GenericResponse<Array<WorkOrderDetailsViewModel>>>(Urls.GetActiveWorkOrder, model).toPromise();
  }

  GetWorkOrderHistoryForVehicle(model: any): Promise<GenericResponse<Array<WorkOrderHistoryViewModel>>> {
    return this.dataProvider.Post<GenericResponse<Array<WorkOrderHistoryViewModel>>>(Urls.GetWorkOrderHistoryForVehicle, model).toPromise();
  }

  GetServicesList(languageCode: string): Promise<any> {
    return this.dataProvider.Get<any>(Urls.GetServicesList,languageCode,0,false).toPromise();
  }
  async ResyncAppointment(appointmentId: number, moduleId: number): Promise<any> {
    return this.dataProvider.Get<GenericResponse<any>>(Urls.ResyncAppointment, appointmentId, moduleId).toPromise();
  }
  async GetAppointmentDayList(): Promise<any> {
    return this.dataProvider.Get<GenericResponse<any>>(Urls.GetAppointmentDayList).toPromise();
  }

  async GetLockedAppointmentList(model):Promise<GenericResponse<any>> {
    return this.dataProvider.Post<GenericResponse<any>>(Urls.GetLockedAppointments, model).toPromise();
  }
  async UnlockAppointment(model):Promise<GenericResponse<any>> {
    return this.dataProvider.Post<GenericResponse<any>>(Urls.UnlockAppointment, model).toPromise();
  }
  async IsLockedByOtherUser(appointmentGuid):Promise<GenericResponse<any>> {
    return this.dataProvider.Get<GenericResponse<any>>(Urls.IsLockedByOtherUser, appointmentGuid).toPromise();
  }
  GetUpdateAppointmentHistory(id:number):Promise<any>{
    return this.dataProvider.Get<any>(Urls.GetUpdateAppointmentHistory,id).toPromise();
  }

  async AddAppointmentJobPackageInDms(jobInfo: AppointmentJobPackageModel): Promise<any> {
    return this.dataProvider.Post<GenericResponse<any>>(Urls.AddAppointmentJobPackageInDms, jobInfo).toPromise();
  }
  ShiftAppointment(dealerId: string, appointmentId: number,remark:string): Promise<any>{
    return this.dataProvider.Get<any>(Urls.ShiftAppointment,dealerId,appointmentId,remark).toPromise();
  }

  AddAppointmentAsQuoteFromRejectedDemand(viewmodel: any): Promise<any> {
    return this.dataProvider.Post<GenericResponse<any>>(Urls.AddAppointmentAsQuoteFromRejectedDemand, viewmodel).toPromise();
  }

  AddAppointmentAsQuoteFromDemand(viewmodel: any): Promise<any> {
    return this.dataProvider.Post<GenericResponse<any>>(Urls.AddAppointmentAsQuoteFromDemand, viewmodel).toPromise();
  }

  SplitDemandsFromExistingAppointment(viewmodel: any): Promise<any> {
    return this.dataProvider.Post<GenericResponse<any>>(Urls.SplitDemandsFromExistingAppointment, viewmodel).toPromise();
  }

  GetDemandWiseDocuments(demandId:number) : Promise<any>{
    return this.dataProvider.Get<any>(Urls.GetDemandWiseDocuments,demandId).toPromise();
  }
  GetFile(url:string) : Promise<any>{
    return this.dataProvider.GetFile<any>(url).toPromise();
  }
  async UploadDocumentFromPlanner(docs:UploadDocumentRequestModel[]): Promise<any>{
    let files: FileUploadModel[] = [];
    docs.forEach(demand => {
      let index = 0;
      demand.Documents.forEach(doc => {
        files.push({
          uniqueId: "file_"+ demand.uniqueId +"_" + index,
          file: doc.actualFile
        });
        doc.imageBinaryData = "";
        index++;
      });
    });
    return this.dataProvider.PostFiles<GenericResponse<any>>(Urls.UploadDocumentFromPlanner, docs, files).toPromise();
  }
  GetDocumentCount(AppointmentId: number): Promise<any> {
    return this.dataProvider.Get<GenericResponse<any>>(Urls.GetDeamandWiseDocumentCount, AppointmentId).toPromise();
  }
  MoveRequestForJobDetails(model:any): Promise<any> {
    return this.dataProvider.Post<GenericResponse<any>>(Urls.MoveRequestForJobDetails, model).toPromise();
  }
  RefreshCustomerData(AppointmentId: number,integrationWithDms:boolean): Promise<any> {
    return this.dataProvider.Get<GenericResponse<any>>(Urls.RefreshCustomerData, AppointmentId,integrationWithDms).toPromise();
  }
  RefreshVehicleData(AppointmentId: number,integrationWithDms:boolean): Promise<any> {
    return this.dataProvider.Get<GenericResponse<any>>(Urls.RefreshVehicleData, AppointmentId,integrationWithDms).toPromise();
  }

  getManualNotificationData(requestModel: any): Promise<GenericResponse<any>> {
    return this.dataProvider.GetAllwithHeaders<GenericResponse<any>>(Urls.ConfirmAppointmentEmail, requestModel).toPromise();
  }

  async GetWorkOrderStatusDetails(model:any):Promise<GenericResponse<any>> {
    return this.dataProvider.Post<GenericResponse<any>>(Urls.GetWorkOrderDetailsReport, model).toPromise();
  }

  async getServiceCampaignOption():Promise<GenericResponse<any>>{
    return this.dataProvider.Get<GenericResponse<any>>(Urls.GetServiceCampaignOption).toPromise();
  }

  async syncDemandToSST(appointmentGUID:any,appointmentId:any):Promise<GenericResponse<any>>{
    return this.dataProvider.Get<GenericResponse<any>>(Urls.SyncDemandToSST,appointmentGUID,appointmentId).toPromise();
  }

  async getCustomerWithMobile(appointmentId: string): Promise<GenericResponse<any>> {
    return this.dataProvider.Get<GenericResponse<any>>(Urls.GetCustomerWithMobile, appointmentId).toPromise();
  }

  async GetSyncFailAppointmentList(appointmentRequestModel: AppointmentRequestModel): Promise<GenericResponse<any>> {
    return this.dataProvider.Post<GenericResponse<any>>(Urls.GetSyncFailAppointmentList, appointmentRequestModel).toPromise();
  }

  async UpdateSyncFailAppointment(appointmentId: any): Promise<GenericResponse<any>> {
    return this.dataProvider.Put<GenericResponse<any>>(Urls.UpdateSyncFailAppointment, appointmentId).toPromise();
  }

  async ReOpenAppointment(workOrderNumber:any): Promise<any> {
    return this.dataProvider.Get<any>(Urls.MoveArchiveAppointmentToActive, workOrderNumber).toPromise();
  }

  async UpdateQuoteExpireDate(appointmentId: any): Promise<GenericResponse<any>> {
    return this.dataProvider.Put<GenericResponse<any>>(Urls.UpdateQuoteExpireDate, appointmentId).toPromise();
  }
}